import authStore from '../../../stores/auth.store';

export const useAuthInfo = () => {
  return authStore?.authInfo;
};
